import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { UIconModule } from '@local/ui-infra';
import { FillPipe } from '@shared/pipes/fill.pipe';

@Component({
  selector: 'result-ghost',
  templateUrl: './result-ghost.component.html',
  styleUrls: ['./result-ghost.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, UIconModule, FillPipe],
})
export class ResultGhostComponent {
  @Input() ghostingLine = 2;
  @Input() galleryView = false;
  @Input() flatView = false;
  @Input() showAvatar = true;
  @Input() width = '100%';
}
